import React, { useEffect, useState } from 'react';
import { Card, Spinner, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import akasiaLogo from "assets/img/illustrations/akasia.png";
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const PagosLista = ({ filters, setID_Pago, setShowModalConciliar }) => {
    const { token } = useToken();
    const { showErrorToast } = useToast();

    const [pagos, setPagos] = useState([]);
    const [cargando, setCargando] = useState(true);
    const [, setPageNumber] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    useEffect(() => {
        if (filters.month && filters.year) {
            setPageNumber(1);
            setHasMore(true);
            ObtenerPagosList(1);
        }
    }, [
        filters.month,
        filters.year,
        filters.idCatCuentaBancaria,
        filters.idCatMedioPago,
        filters.idVendedor,
        filters.filterValidados,
        filters.filterStatus
    ]);

    const fetchMoreData = () => {
        setPageNumber(prev => {
            const next = prev + 1;
            ObtenerPagosList(next);
            return next;
        });
    };

    const ObtenerPagosList = async (page = 1) => {
        if (page === 1) {
            setCargando(true);
            setPagos([]);
        }

        const url = `/api/AdministracionPagos/ObtenerPagosList/?month=${filters.month}&year=${filters.year}&idCatCuentaBancaria=${filters.idCatCuentaBancaria}&idMedioPago=${filters.idCatMedioPago}&idVendedor=${filters.idVendedor}&iValidado=${filters.filterValidados}&iEstatus=${filters.filterStatus}&pageNumber=${page}&pageSize=30`;

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('' + error.message);
        });

        if (response && response.ok) {
            const objResponse = await response.json();
            if (objResponse.iResponseType == 1) {
                const data = JSON.parse(objResponse.detalles);
                const table2 = data['table2'] || [];
                if (page === 1) {
                    setPagos(table2);
                } else {
                    setPagos(prev => [...prev, ...table2]);
                }
                if (table2.length < 30) {
                    setHasMore(false);
                }
            } else {
                showErrorToast(objResponse.vMessage);
            }
        }
        if (page === 1) setCargando(false);
    };

    const columns = [
        {
            accessor: 'none1',
            Header: '',
            Cell: rowData => {
                const { idPago } = rowData.row.original;
                return (
                    <Button
                        variant="link"
                        size="sm"
                        className="text-500 shadow-none p-0"
                        title="Ver informaci&oacute;n"
                        onClick={() => { setID_Pago(idPago); setShowModalConciliar(true) }}
                    >
                        <FontAwesomeIcon icon="eye" />
                    </Button>
                );
            }
        },
        {
            accessor: 'idPago',
            Header: 'ID',
            Cell: rowData => {
                const { idPago } = rowData.row.original;
                return (
                    <Link onClick={() => { setID_Pago(idPago); setShowModalConciliar(true) }} className="fw-semi-bold text-dark">
                        {idPago}
                    </Link>
                );
            }
        },
        {
            accessor: 'none',
            Header: 'Estatus',
            Cell: rowData => {
                const { bIsActive, bIsFacturado, idCatCuentaBancaria } = rowData.row.original;
                return (
                    <div className="d-flex align-items-center gap-1">
                        <img title={bIsActive == 1 ? "Activo" : "No Activo"} src={bIsActive == 1 ? "/img/activo.png" : "/img/noactivo.png"} alt="status" />
                        <img title={idCatCuentaBancaria > 0 ? "Validado" : "No Validado"} src={idCatCuentaBancaria > 0 ? "/img/activo.png" : "/img/noactivo.png"} alt="validado" />
                        <img title={bIsFacturado == 1 ? "Conciliado" : "No Conciliado"} src={bIsFacturado == 1 ? "/img/activo.png" : "/img/noactivo.png"} alt="conciliado" />
                    </div>
                );
            }
        },
        {
            accessor: 'idOrden',
            Header: 'Orden',
            Cell: rowData => {
                const { idOrden, vNombreCliente, bIsActive, bIsRecompra, bIsDistribucion } = rowData.row.original;
                return (
                    <div className="d-flex flex-column" style={{ maxWidth: '200px' }}>
                        <Link to={"/ordenes/detalle/" + idOrden} className={classNames("fw-bold text-truncate", { "text-danger": bIsActive == false })}>
                            #{idOrden}
                        </Link>
                        <span className={classNames("text-600 text-truncate", { "text-danger text-decoration-line-through": bIsActive == false })}>
                            {bIsDistribucion == null ? "" : bIsDistribucion == 1 ? "🎖️ " : bIsDistribucion == 0 ? <img width="12" src={akasiaLogo} alt="logo" className="me-1" /> : ""}
                            {bIsRecompra == 1 && "♻ "}
                            {vNombreCliente}
                        </span>
                    </div>
                );
            }
        },
        {
            accessor: 'dFechaPagoLargo',
            Header: 'Fecha Pago',
            Cell: rowData => (
                <span className="text-dark">
                    {rowData.row.original.dFechaPagoLargo}
                </span>
            )
        },
        {
            accessor: 'vUsuario',
            Header: 'Vendedor',
            Cell: rowData => (
                <span className="text-dark text-uppercase text-truncate d-inline-block" style={{ maxWidth: '80px' }}>
                    {rowData.row.original.vUsuario}
                </span>
            )
        },
        {
            accessor: 'dImportePago',
            Header: 'Importe Pago',
            Cell: rowData => (
                <span className="fw-bold text-dark text-end d-block">
                    ${parseFloat(rowData.row.original.dImportePago).toLocaleString("es-MX", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                </span>
            )
        },
        {
            accessor: 'vMoneda',
            Header: 'Moneda',
            Cell: rowData => {
                const { vMoneda, dTipoCambio } = rowData.row.original;
                return (
                    <span className="text-500" style={{ fontSize: '0.8rem' }}>
                        {vMoneda} {vMoneda == "MXN" ? "" : " T.C. " + parseFloat(dTipoCambio).toFixed(4)}
                    </span>
                );
            }
        },
        {
            accessor: 'vReferencia',
            Header: 'Referencia',
            Cell: rowData => (
                rowData.row.original.vReferencia ?
                    <span className="text-primary fw-semi-bold text-truncate d-inline-block" style={{ maxWidth: '100px' }} title={rowData.row.original.vReferencia}>
                        {rowData.row.original.vReferencia}
                    </span>
                    : <span className="text-400">-</span>
            )
        },
        {
            accessor: 'vMedioPago',
            Header: 'Medio de Pago',
            Cell: rowData => {
                const { vMedioPago } = rowData.row.original;
                return (
                    <div className="d-flex align-items-center gap-1 fw-semi-bold text-700">
                        {vMedioPago == 'EFECTIVO' && <img src="/img/efectivo20.png" alt="efectivo" width="16" />}
                        {vMedioPago == 'STRIPE' && <img src="/img/stripe30.png" alt="stripe" width="24" />}
                        {vMedioPago == 'PAYPAL' && <img src="/img/paypal20.png" alt="paypal" width="16" />}
                        {vMedioPago == 'BANCO' && <img src="/img/transferencia20.png" alt="banco" width="16" />}
                        <span className="text-truncate" style={{ maxWidth: '60px' }}>{vMedioPago}</span>
                    </div>
                );
            }
        },
        {
            accessor: 'vDescripcionFormaPago',
            Header: 'Forma de Pago',
            Cell: rowData => {
                const { vClave, vDescripcionFormaPago } = rowData.row.original;
                return (
                    <div className="d-flex align-items-center gap-1 fw-semi-bold text-600">
                        {vClave == '01' && <img src="/img/efectivo20.png" alt="fp" width="16" />}
                        {vClave == '03' && <img src="/img/transferencia20.png" alt="fp" width="16" />}
                        {vClave == '99' && <img src="/img/pordefinir20.png" alt="fp" width="16" />}
                        {vClave == '28' && <img src="/img/tarjeta20.png" alt="fp" width="16" />}
                        {vClave == '04' && <img src="/img/tarjeta20.png" alt="fp" width="16" />}
                        {vClave == '31' && <img src="/img/intermediario20.png" alt="fp" width="16" />}
                        <span className="text-truncate" style={{ maxWidth: '100px' }} title={`${vClave} - ${vDescripcionFormaPago}`}>
                            {vClave} - {vDescripcionFormaPago}
                        </span>
                    </div>
                );
            }
        }
    ];

    return (
        <>
            <AdvanceTableWrapper
                columns={columns}
                data={pagos}
                sortable
                pagination={true}
                perPage={100000}
            >
                <div className="row m-0 justify-content-end px-3 py-2 border-bottom">
                    <div className="col-12 col-md-4">
                        {!cargando && <AdvanceTableSearchBox table />}
                    </div>
                </div>

                <InfiniteScroll
                    dataLength={pagos.length}
                    next={fetchMoreData}
                    hasMore={hasMore && !cargando}
                    height="65vh"
                    loader={<div className="p-3 text-center"><Spinner className="text-inline" animation="border" variant="primary" size="sm" /> <span>Cargando más pagos...</span></div>}
                    endMessage={
                        !cargando && pagos.length > 0 && (
                            <p style={{ textAlign: 'center' }} className="py-3 text-500 mb-0 fs--1">
                                <b>No hay más pagos para mostrar</b>
                            </p>
                        )
                    }
                >
                    <Card.Body className="p-0 position-relative" style={{ minHeight: '200px' }}>
                        <CustomTable table cargando={cargando} />
                    </Card.Body>
                </InfiniteScroll>
            </AdvanceTableWrapper>

        </>
    );
};

PagosLista.propTypes = {
    filters: PropTypes.object.isRequired,
    setID_Pago: PropTypes.func.isRequired,
    setShowModalConciliar: PropTypes.func.isRequired
};

export default PagosLista;

const CustomTable = ({ getTableProps, headers, page, prepareRow, cargando }) => {
    return (
        <Table {...getTableProps()} size="sm" striped className="fs--2 mb-0">
            <thead className="bg-200 text-900 text-nowrap align-middle" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                <tr>
                    {headers.map((column, index) => (
                        <th
                            key={index}
                            {...column.getHeaderProps(column.getSortByToggleProps(column.headerProps))}
                        >
                            {column.render('Header')}
                            {column.canSort ? (
                                column.isSorted ? (
                                    column.isSortedDesc ? <span className="sort desc" /> : <span className="sort asc" />
                                ) : <span className="sort" />
                            ) : ''}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody className="align-middle white-space-nowrap">
                {cargando && page.length === 0 ? (
                    <tr>
                        <td colSpan={headers.length} className="text-center py-5">
                            <Spinner animation="border" variant="primary" />
                            <h5 className="mt-2 text-600">Cargando pagos...</h5>
                        </td>
                    </tr>
                ) : !cargando && page.length === 0 ? (
                    <tr>
                        <td colSpan={headers.length} className="text-center py-5">
                            <h5 className="text-500 mb-0">No se encontraron resultados</h5>
                        </td>
                    </tr>
                ) : (
                    page.map((row, i) => {
                        prepareRow(row);
                        return (
                            <tr key={i} {...row.getRowProps()}>
                                {row.cells.map((cell, index) => (
                                    <td key={index} {...cell.getCellProps(cell.column.cellProps)}>
                                        {cell.render('Cell')}
                                    </td>
                                ))}
                            </tr>
                        );
                    })
                )}
            </tbody>
        </Table>
    );
};

CustomTable.propTypes = {
    getTableProps: PropTypes.func.isRequired,
    headers: PropTypes.array.isRequired,
    page: PropTypes.array.isRequired,
    prepareRow: PropTypes.func.isRequired,
    cargando: PropTypes.bool.isRequired
};
